<template>
  <div>
    <Form ref="formItems" :model="formValue" :rules="formValidate" :label-width="100">
      <FormItem type="flex" label="统计范围：" prop="countExtent">
        <RadioGroup v-model="formValue.countExtent" @on-change="selectCountExtent">
          <Radio label="drawArea">绘制</Radio>
          <Radio label="xzqh">行政区划</Radio>
        </RadioGroup>
        <div class="btnstyle" v-if="formValue.countExtent == 'drawArea'">
          <Row>
            <Col span="24">
              <div class="iconstyle" @click="drawArea('Box')">
                <img src="../../../../static/image/analysis/面/fill_un.png" />
                <div class="text">面</div>
              </div>
              <div class="iconstyle" @click="drawArea('Polygon')">
                <img src="../../../../static/image/analysis/异形/poly_un.png" />
                <div class="text">多边形</div>
              </div>
              <Upload
                style="float: left"
                :show-upload-list="false"
                accept=".txt"
                :before-upload="txtBeforupload"
                action
              >
                <div class="iconstyle" style="margin-left: -3px">
                  <img src="../../../../static/image/analysis/txt/txt_un.png" />
                  <div class="text">上传txt</div>
                </div>
              </Upload>
              <Upload
                style="float: left"
                :show-upload-list="false"
                accept=".shp"
                :before-upload="shpBeforupload"
                :on-success="handleSuccess"
                :headers="accessToken"
                action="/zituSpace/polygonGeojsonData/uploadShpToGeojsonStr"
              >
                <div class="iconstyle">
                  <img src="../../../../static/image/analysis/shp/shp_un.png" />
                  <div class="text">上传shp</div>
                </div>
              </Upload>
              <div class="iconstyle" @click="drawArea('delete')">
                <img src="../../../../static/image/analysis/删除/del_un.png" />
                <div class="text">删除</div>
              </div>
            </Col>
          </Row>
        </div>
        <Cascader
          :data="proviceDataList"
          v-model="selectAreaForm"
          change-on-select
          transfer
          @on-change="selectArea"
          v-else
        ></Cascader>
      </FormItem>
      <FormItem label="统计方式：" prop="countType">
        <RadioGroup v-model="formValue.countType" @on-change="selectCountType">
          <Radio label="classification">分类</Radio>
          <!-- <Radio label="subsection">分段</Radio> -->
        </RadioGroup>
      </FormItem>
      <FormItem label="分类字段：" prop="countField">
        <Select v-model="countField">
          <Option v-for="(item, i) in propertyArr" :value="item.key" :key="i"
            >{{ item.alias ? item.alias : item.key }}
          </Option>
        </Select>
      </FormItem>
      <FormItem label="分段数据：" prop="countType" v-if="formValue.countType == 'subsection'">
        <ul class="subsectionCal">
          <li v-for="(nav, index) in subsectionValueArr" :key="index" class="lis">
            <Input v-model="nav.valueOne" type="number" class="inputCal leftInput"></Input>
            -
            <Input v-model="nav.valueTwo" type="number" class="inputCal"></Input>
            <div :class="index === 0 ? 'noiconfontCal' : 'iconfontCal'">
              <i class="iconfont icon-zengjia" @click="addSubsection"></i>
              <i
                class="iconfont icon-jianshaojianqujianhao"
                @click="reduceSubsection(index)"
                v-if="index !== 0"
              ></i>
            </div>
          </li>
        </ul>
      </FormItem>
      <FormItem type="flex" label="统计类型：" prop="formItems" class="selty">
        <div v-for="(item, index) in formItems" :key="index" style="margin-top: 5px">
          <Row>
            <Col span="8">
              <Select v-model="item.countWay" style="width: 85px">
                <Option v-for="(items, i) in tjfsArr" :value="items.value" :key="i">{{
                  items.name
                }}</Option>
              </Select>
            </Col>
            <Col span="16">
              <Select v-model="item.countField" placeholder="统计字段">
                <Option
                  v-for="(itm, i) in propertyArr"
                  :value="itm.key"
                  :key="i"
                  v-if="item.countWay == 'Count'"
                  >{{ itm.alias ? itm.alias : itm.key }}</Option
                >
                <Option
                  v-for="(itm, i) in propertyArr"
                  :value="itm.key"
                  :key="i"
                  v-if="item.countWay != 'Count' && itm.type == 'number'"
                  >{{ itm.alias ? itm.alias : itm.key }}</Option
                >
              </Select>
            </Col>
          </Row>
        </div>
      </FormItem>

      <FormItem style="text-align: center; margin-left: -85px">
        <Button @click="handleReset" icon="md-refresh" style="width: 110px; margin-left: 30px"
          >重置</Button
        >
        <Button
          type="primary"
          icon="ios-podium"
          :loading="submitLoading"
          @click="handleSubmit"
          style="width: 110px; margin-left: 30px"
          >统计</Button
        >
      </FormItem>
    </Form>

    <div class="demo-spin-container" v-if="spintj">
      <Spin fix></Spin>
    </div>
    <Modal v-model="modal1" :footer-hide="true" width="60%" :mask="false">
      <p class="modeltitle" slot="header" style="font-size: 14px; color: rgba(51, 51, 51, 1)">
        <i></i>
        <span>统计结果展示</span>
      </p>
      <div class="modelcontent" style="width: 100%; height: 100%">
        <Select
          v-model="selectFi"
          style="width: 200px"
          class="selefi"
          @on-change="selectoutstatistic"
        >
          <Option v-for="(field, inx) in outStatisticField" :value="field.value" :key="inx">{{
            field.name
          }}</Option>
        </Select>
        <Tabs type="card" @on-click="tabtest" style="width: 100%; height: 100%">
          <TabPane label="柱状图" style="width: 100%">
            <div style="height: 380px" class="box1 chart_container1"></div>
            <Button
              style="float: right; margin-top: 8px"
              type="primary"
              :loading="submitLoading"
              @click="exportpic('柱状图')"
              >导出</Button
            >
          </TabPane>
          <TabPane label="饼状图">
            <div style="height: 380px" class="box1 chart_container3"></div>
            <Button
              style="float: right; margin-top: 8px"
              type="primary"
              :loading="submitLoading"
              @click="exportpic('饼状图')"
              >导出</Button
            >
          </TabPane>
          <TabPane label="折线图">
            <div style="height: 380px" class="box1 chart_container2"></div>
            <Button
              style="float: right; margin-top: 8px"
              type="primary"
              :loading="submitLoading"
              @click="exportpic('折线图')"
              >导出</Button
            >
          </TabPane>
          <TabPane label="统计表">
            <!-- <table class="layui-hide" id="objinfor" ></table> -->
            <Table
              height="380"
              width="90%"
              ref="tabletj"
              border
              :columns="columns_table"
              :data="tjdata"
            ></Table>

            <Button
              style="float: right; margin-top: 8px"
              v-if="tjdata.length > 0"
              type="primary"
              :loading="submitLoading"
              @click="exportpic('统计表')"
              >导出Excel</Button
            >
          </TabPane>
        </Tabs>
      </div>
    </Modal>
  </div>
</template>
<script>
import statisticsQuery from './statisticsQuery';
export default statisticsQuery;
</script>
<style lang="less" scoped>
.selefi {
  width: 200px;
  position: absolute;
  right: 20px;
  margin-top: -10px;
  border: 1px #2d8cf0 solid;
  z-index: 9999;
}

/deep/ .selty .ivu-form-item-content {
  background: rgba(243, 242, 242, 1);
}

/deep/ .selty .addbtn {
  width: 20px;
  height: 20px;
  border: 0px;
  background: #f3f2f2;
  margin-top: 8px;

  .ivu-icon {
    line-height: 0;
  }
}

.btnstyle button {
  width: 50px;
  height: 20px;
  font-size: 12px;
}

.iconstyle {
  float: left;
  width: 50px;
  text-align: center;
  list-style: none;
  cursor: pointer;
  height: 20px;
  color: #5c6b77;
  transition: all 0.2s ease;
  position: relative;
}

.iconstyle img {
  display: inline-block;
  text-align: center;
}

.iconstyle .text {
  text-align: center;
  font-size: 12px;
  width: 50px;
  line-height: 15px;
  margin-top: -5px;
}

.btnstyle .primery {
  color: #57a3f3;
  background-color: #fff;
  border-color: #57a3f3;
}

.btnstyle .selected {
  background-color: #0099fa;
  color: white;
}

.btnstyle button.selected .box {
  background-image: url(../../../../static/image/stastic/poly.png);
}

.btnstyle button.selected .circle {
  background-image: url(../../../../static/image/stastic/circle.png);
}

.btnstyle button.selected .dbx {
  background-image: url(../../../../static/image/stastic/dbx.png);
}

.btnstyle button.selected .del {
  background-image: url(../../../../static/image/stastic/del.png);
}

.btnstyle button .ivu-icon {
  width: 16px;
  height: 14px;
  margin-left: -15px;
}

.btnstyle button .box {
  background-image: url(../../../../static/image/stastic/poly_se.png);
}

.btnstyle button .circle {
  background-image: url(../../../../static/image/stastic/circle_se.png);
}

.btnstyle button .dbx {
  background-image: url(../../../../static/image/stastic/dbx_se.png);
}

.btnstyle button .del {
  background-image: url(../../../../static/image/stastic/del_se.png);
}

.btnstyle button:hover {
  background-color: #0099fa;
  color: white;
}

.btnstyle button:hover .box {
  background-image: url(../../../../static/image/stastic/poly.png);
}

.btnstyle button:hover .circle {
  background-image: url(../../../../static/image/stastic/circle.png);
}

.btnstyle button:hover .dbx {
  background-image: url(../../../../static/image/stastic/dbx.png);
}

.btnstyle button:hover .del {
  background-image: url(../../../../static/image/stastic/del.png);
}

.btnstyle .ivu-btn > .ivu-icon + span,
.btnstyle .ivu-btn > span + .ivu-icon {
  margin-left: 0px;
}

.box1 {
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  margin-left: 20px;
  margin-right: 0px;
}

.demo-spin-container {
  display: inline-block;
  width: 200px;
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

/deep/ .ivu-modal-body {
  height: 500px;
  // overflow: scroll;
}

.modeltitle {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}

.modeltitle i {
  border-radius: 2px;
  background: #3d92dc;
  width: 4px;
  height: 30px;
  float: left;
  margin: 0px 5px 0 20px;
}

.subsectionCal {
  .lis {
    width: 100%;
    display: flex;

    .inputCal {
      width: 35%;
    }

    .iconfontCal {
      flex: 1;
      text-align: center;

      .icon-zengjia {
        font-size: 30px;
        cursor: pointer;
      }

      .icon-jianshaojianqujianhao {
        font-size: 30px;
        cursor: pointer;
      }
    }

    .noiconfontCal {
      flex: 1;
      text-align: left;

      .icon-zengjia {
        font-size: 30px;
        cursor: pointer;
        margin-left: 6px;
      }
    }
  }
}

/deep/.ivu-form-item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftmenu/statistics/statisticsQuery.vue